import React from 'react';
import Share from '@material-ui/icons/Share';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, IconButton } from '@material-ui/core';
import { InsightDispatch, iRootState } from '../../redux/store';
import { AmplitudeEventKeys } from '../../Constants';

const ShareIcon = function ShareIcon(): React.ReactElement {
  const dispatch = useDispatch<InsightDispatch>();
  const pendingApprovals = useSelector(
    (state: iRootState) => state.shareDataManufacturers.pendingApprovalsCount
  );

  const onClick = function handleOnClick(): void {
    dispatch.shareCenter.toggleOpen();
    dispatch.amplitude.sendEvent({
      eventType: AmplitudeEventKeys.ShareButtonClicked
    });
  };

  return (
    <IconButton color='inherit' onClick={onClick}>
      <Badge badgeContent={pendingApprovals} color='error'>
        <Share />
      </Badge>
    </IconButton>
  );
};

export default ShareIcon;
